import React from "react";
import { Activity } from "lucide-react";

export function Logo({ light = false, className = "" }) {
  const text = light ? "text-white" : "text-[#0F2747]";
  return (
    <div className={`flex items-center gap-2 ${className}`} data-testid="brand-logo">
      <div className="flex h-9 w-9 items-center justify-center rounded-xl bg-[#18A6A6] shadow-sm">
        <Activity className="h-5 w-5 text-white" strokeWidth={2.5} />
      </div>
      <span className={`font-heading text-lg font-extrabold tracking-tight ${text}`}>
        RN Level Up
      </span>
    </div>
  );
}
